import { render, staticRenderFns } from "./IrReportsSearch.vue?vue&type=template&id=78732ceb&"
import script from "./IrReportsSearch.vue?vue&type=script&lang=js&"
export * from "./IrReportsSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports